import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const CustomSelect = ({
  name,
  options,
  formik,
  placeholder,
  handleChangeExtra,
}) => {
  return (
    <Select
      name={name}
      className="text-sm"
      classNamePrefix="react-select"
      options={options}
      components={{
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null,
      }}
      value={options?.find((opt) => opt?.value === formik.values[name])}
      onChange={(selectedOption) => {
        formik.setFieldValue(name, selectedOption?.value || "");
        if (handleChangeExtra) handleChangeExtra(selectedOption);
      }}
      filterOption={(option, inputValue) =>
        option?.label?.toLowerCase().includes(inputValue.toLowerCase())
      }
      placeholder={placeholder}
      isClearable
      menuPlacement="auto"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: "35px",
          height: "auto",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
          boxShadow: state.isFocused ? "none" : "none",
          "&:hover": { borderColor: "#DFDFDF" },
          fontSize: "13px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: "#1E1E1E",
          padding: "0 14px",
          cursor: state.isDisabled ? "not-allowed" : "normal",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "auto",
          padding: "0 0px 0",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          fontSize: "14px",
          height: "auto",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "14px",
          color: "#717680",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        menu: (base) => ({
          ...base,
          marginTop: "2px",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: state.isSelected ? "#FFF" : "#1E1E1E",
          backgroundColor: state.isSelected
            ? "#3b82f6"
            : state.isFocused
            ? "#F3F4F6"
            : "#FFF",
          padding: "8px 14px",
          cursor: "pointer",
        }),
        indicatorContainer: (base) => ({ ...base, padding: 0 }),
        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
      }}
    />
  );
};
const AddHealthScoreThresholds = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (editData?.id) {
      formik.setFieldValue("min_score", editData?.min_score);
      formik.setFieldValue("max_score", editData?.max_score);
      formik.setFieldValue("health_status", editData?.health_status);
      formik.setFieldValue("action_required", editData?.action_required);
      formik.setFieldValue("color", editData?.color);
    }
  }, [editData]);

 

  const validationSchema = yup.object({
    health_status: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    min_score: yup
      .number("This Field is Required")
      .required("This Field is Required"),
    action_required: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    color: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    max_score: yup
      .number("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      health_status: "",
      min_score: "",
      action_required: "",
      color: "",
      max_score: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let data = {
        health_status: values.health_status,
        min_score: values.min_score,
        action_required: values.action_required,
        color: values.color,
        max_score: values.max_score,
      };

     
      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `health-score-thresholds/update-threshold/${editData?.id}`
            : `health-score-thresholds/add-threshold`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>
            {editData?.id
              ? "Edit Health Score Thresholds"
              : "Add Health Score Thresholds"}
          </h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Health Status */}
                  <FeildWraper width="100%">
                    <FormLabel required>Health Status</FormLabel>
                    <input
                      type="text"
                      name="health_status"
                      value={formik.values.health_status}
                      onChange={formik.handleChange}
                      placeholder="Health Status"
                    />
                    {formik.touched.health_status &&
                      formik.errors.health_status && (
                        <FeildError>{formik.errors.health_status}</FeildError>
                      )}
                  </FeildWraper>

                  {/* min_score */}
                  <FeildWraper>
                    <FormLabel required>Min Score</FormLabel>
                    <input
                      type="number"
                      name="min_score"
                      min="0"
                      value={formik.values.min_score}
                      onChange={formik.handleChange}
                      placeholder="Min Score"
                    />
                    {formik.touched.min_score && formik.errors.min_score && (
                      <FeildError>{formik.errors.min_score}</FeildError>
                    )}
                  </FeildWraper>

                  {/* max_score */}
                  <FeildWraper>
                    <FormLabel required>Max Score</FormLabel>
                    <input
                      type="number"
                      name="max_score"
                      min="0"
                      value={formik.values.max_score}
                      onChange={formik.handleChange}
                      placeholder="Max Score"
                    />
                    {formik.touched.max_score && formik.errors.max_score && (
                      <FeildError>{formik.errors.max_score}</FeildError>
                    )}
                  </FeildWraper>

                  {/* action_required */}

                  <FeildWraper>
                    <FormLabel required>Action Required</FormLabel>
                    <input
                      type="text"
                      name="action_required"
                      value={formik.values.action_required}
                      onChange={formik.handleChange}
                      placeholder="Action Required"
                    />
                    {formik.touched.action_required &&
                      formik.errors.action_required && (
                        <FeildError>{formik.errors.action_required}</FeildError>
                      )}
                  </FeildWraper>

                  {/* color */}

                  <FeildWraper>
                    <FormLabel required>Color</FormLabel>
                    <input
                      type="text"
                      name="color"
                      value={formik.values.color}
                      onChange={formik.handleChange}
                      placeholder="Color"
                    />
                    {formik.touched.color && formik.errors.color && (
                      <FeildError>{formik.errors.color}</FeildError>
                    )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddHealthScoreThresholds;
